import React, { useEffect } from "react";
import ApplicantCoachPanel from "../components/applicant/ApplicantCoachPanel";
import { useApplicantCoach } from "../components/applicant/ApplicantCoachContext";
import ApplicantDashboard from "./ApplicantDashboard";

export default function ApplicantDashboardWithCoach() {
  const { registerCoachSurface } = useApplicantCoach();

  useEffect(() => {
    registerCoachSurface({
      screen_key: "applicant_dashboard",
      screen_label: "Applicant Dashboard",
      highlighted_step: "Naechster sinnvoller Schritt im Dashboard",
    });
  }, [registerCoachSurface]);

  return (
    <>
      <ApplicantDashboard />
      <ApplicantCoachPanel />
    </>
  );
}
